"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Water = void 0;
const three_9 = require("three");
const OrbitControls_1 = require("three/examples/jsm/controls/OrbitControls");
const GLTFLoader_js_1 = require("three/examples/jsm/loaders/GLTFLoader.js");
const Water_Shader_1 = require("./shaders/Water.Shader");
const tweakpane_2 = require("tweakpane");
//
class Water {
    constructor() {
        // this.init();
        this.elapsedTime = 0;
        this.previousRenderScene = this.renderScene;
        this.sizes = {
            width: 0,
            height: 0
        };
        this.tick = () => {
            window.requestAnimationFrame(this.tick);
            if (this.renderScene !== this.previousRenderScene) {
                this.previousRenderScene = this.renderScene;
                if (this.waterTwp) {
                    this.waterTwp.hidden = !this.renderScene;
                }
            }
            //
            this.delta = this.clock.getDelta() * 1000;
            this.elapsedTime += this.delta;
            //
            if (this.sizes.width !== window.innerWidth || this.sizes.height !== window.innerHeight) {
                this.resize();
            }
            // render scene into target
            this.waterMesh.visible = false;
            this.renderer.setRenderTarget(this.target);
            this.renderer.render(this.scene, this.camera);
            this.mapControls.update();
            this.renderer.setRenderTarget(null);
            this.waterMesh.visible = true;
            this.waterMaterial.uniforms.tDepth.value = this.target.depthTexture;
            this.waterMaterial.uniforms.cameraNear.value = this.camera.near;
            this.waterMaterial.uniforms.cameraFar.value = this.camera.far;
            this.waterMaterial.uniforms.uTime.value = Math.sin(this.elapsedTime / 1068) + 2; //1068
            this.renderer.render(this.scene, this.camera);
        };
    }
    ;
    init() {
        // Canvas
        this.canvas = document.querySelector('canvas.webglViewWater');
        // Scene
        this.scene = new three_9.Scene();
        this.scene.background = new three_9.Color('#c7c1b7');
        // Camera
        this.camera = new three_9.PerspectiveCamera(45, this.sizes.width / this.sizes.height, 0.1, 100);
        this.camera.position.set(1, 2, 2);
        this.scene.add(this.camera);
        // Controls
        this.mapControls = new OrbitControls_1.MapControls(this.camera, this.canvas);
        this.mapControls.enableDamping = true;
        // Light
        const light = new three_9.PointLight(0xe9f7ec, 1, 100);
        light.position.set(5, 5, 5);
        this.scene.add(light);
        // Plane
        this.loadPlane();
        // Water
        let waterGeom = new three_9.PlaneGeometry(1.9, 1.9);
        this.waterMaterial = new Water_Shader_1.WaterMaterial();
        this.waterMesh = new three_9.Mesh(waterGeom, this.waterMaterial);
        this.waterMesh.rotation.x = -Math.PI / 2;
        this.waterMesh.position.set(0, -0.05, 0);
        this.scene.add(this.waterMesh);
        // Renderer
        this.renderer = new three_9.WebGLRenderer({ canvas: this.canvas });
        this.renderer.setSize(this.sizes.width, this.sizes.height);
        this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
        this.scene.add(new three_9.Mesh(new three_9.BoxGeometry(0.2, 0.2, 0.2), new three_9.MeshBasicMaterial({ color: 0xebb734 })));
        // Create a render target with depth texture
        this.setupRenderTarget();
        // Resize
        window.addEventListener('resize', this.resize());
        this.debug();
        this.clock = new three_9.Clock();
        //
        this.tick();
    }
    ;
    debug() {
        // Debug
        let props = { waterColor: '#8eb4e6' };
        this.waterTwp = new tweakpane_2.Pane({ title: "Water", expanded: true });
        this.waterTwp.element.parentElement.style['width'] = '330px';
        this.waterTwp.element.parentElement.style['margin-top'] = '80px';
        this.waterTwp.element.parentElement.style['z-index'] = '18';
        this.waterTwp.addInput(props, 'waterColor', { view: 'color', alpha: true, label: 'inner color' }).on('change', (ev) => {
            this.waterMaterial.uniforms.uColor.value.setHex(parseInt(ev.value.replace('#', '0x')));
        });
        this.waterTwp.hidden = !this.renderScene;
    }
    ;
    findingDepth() {
        // Setup post processing stage
        this.postCamera = new three_9.OrthographicCamera(-1, 1, 1, -1, 0, 1);
        this.postMaterial = new three_9.ShaderMaterial({
            vertexShader: `
            varying vec2 vUv;

            void main() {
                vUv = uv;
                gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
            }
            `,
            fragmentShader: `
            #include <packing>

            varying vec2 vUv;
            uniform sampler2D tDiffuse;
            uniform sampler2D tDepth;
            uniform float cameraNear;
            uniform float cameraFar;


            float readDepth( sampler2D depthSampler, vec2 coord ) {
                float fragCoordZ = texture2D( depthSampler, coord ).x;
                float viewZ = perspectiveDepthToViewZ( fragCoordZ, cameraNear, cameraFar );
                return viewZToOrthographicDepth( viewZ, cameraNear, cameraFar );
            }

            void main() {
                //vec3 diffuse = texture2D( tDiffuse, vUv ).rgb;
                float depth = readDepth( tDepth, vUv );

                gl_FragColor.rgb = 1.0 - vec3( pow( depth, 0.2 ) );
                gl_FragColor.a = 1.0;
            }
            `,
            uniforms: {
                cameraNear: { value: this.camera.near },
                cameraFar: { value: this.camera.far },
                tDiffuse: { value: null },
                tDepth: { value: null }
            }
        });
        const postPlane = new three_9.PlaneGeometry(2, 2);
        const postQuad = new three_9.Mesh(postPlane, this.postMaterial);
        this.postScene = new three_9.Scene();
        this.postScene.add(postQuad);
    }
    ;
    loadPlane() {
        // Loading tree
        this.loader = new GLTFLoader_js_1.GLTFLoader();
        this.loader.load('resources/models/plane.gltf', (gltf) => {
            gltf.scene.children[0].scale;
            this.scene.add(gltf.scene.children[0]);
        });
    }
    ;
    setupRenderTarget() {
        if (this.target)
            this.target.dispose();
        //
        this.target = new three_9.WebGLRenderTarget(window.innerWidth, window.innerHeight);
        this.target.texture.format = three_9.RGBFormat;
        this.target.texture.minFilter = three_9.NearestFilter;
        this.target.texture.magFilter = three_9.NearestFilter;
        this.target.texture.generateMipmaps = false;
        this.target.stencilBuffer = false;
        this.target.depthBuffer = true;
        this.target.depthTexture = new three_9.DepthTexture(window.innerWidth, window.innerHeight);
        this.target.depthTexture.type = three_9.UnsignedShortType;
        this.target.depthTexture.format = three_9.DepthFormat;
    }
    ;
    resize() {
        this.sizes.width = window.innerWidth;
        this.sizes.height = window.innerHeight;
        this.camera.aspect = this.sizes.width / this.sizes.height;
        this.camera.updateProjectionMatrix();
        const dpr = this.renderer.getPixelRatio();
        this.target.setSize(window.innerWidth * dpr, window.innerHeight * dpr);
        this.renderer.setSize(this.sizes.width, this.sizes.height);
    }
    ;
}
exports.Water = Water;
;
exports.default = new Water();
